module.exports = __webpack_public_path__ + "img/ejecutivo6.2d1fb714.png";